import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  IconButton,
  Typography,
  Button,
  TextField,
  Autocomplete,
  Grid,
  Divider,
  Checkbox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import BackspaceIcon from "@mui/icons-material/Backspace";
import {
  getRequest,
  postFormDataRequest,
} from "../../../../services/api/axios_api_Request";
import PermissionsTable from "../../PermissionsTable/adduserpermission/PermissionsTable";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import "./AddUserModal.scss"; // Import your SCSS file
import { toast } from "react-toastify";

const AddUserModal = ({ addUserOpen, handleAddUserClose }) => {
  const [appData, setAppData] = useState([]);
  const [userIds, setUserIds] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [sowIds, setSowIds] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [permissions, setPermissions] = useState([
    {
      application: "",
      access_level: "",
      read: false,
      write: false,
      delete: false,
    },
  ]);
  const [imagePreview, setImagePreview] = useState(null);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  console.log("perm in add user", permissions);
  const superAdminOptions = [
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];
  const [newUser, setNewUser] = useState({
    userId: "",
    username: "",
    email: "",
    status: "",
    isSuperAdmin: 0,
    clients: "",
    deptId: "",
    sowId: [],
    sows: "",
    allowed_app_ids: [],
  });
  console.log("current user data inside adduser modal", newUser);

  // Fetch data when modal is open
  useEffect(() => {
    const fetchClientData = async () => {
      try {
        const res = await getRequest("admin/unique-clients");
        if (res?.status === 200) {
          const clientsData = res?.data?.clients || [];
          // Map the response to format the client names and ids for the UI
          const formattedClients = clientsData.map((client) => ({
            label: client.client_name, // this will be displayed in the UI
            id: client.client_id, // this will be sent to the backend
          }));
          setClientData(formattedClients);
        } else {
          console.error("Failed to fetch clients data:", res);
        }
      } catch (error) {
        console.error("Error fetching clients data:", error);
      }
    };
    const fetchDepartments = async () => {
      console.log("inside fetchDepartments");

      try {
        const res = await getRequest("admin/unique-departments");
        if (res?.status === 200) {
          const departmentsData = res?.data?.dept_list || [];
          setDepartments(departmentsData);
        } else {
          console.error("Failed to fetch departments:", res);
        }
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };
    const fetchSowIds = async () => {
      try {
        console.log("inside fetchsow is");

        const res = await getRequest("admin/sowid-title-list");
        if (res?.status === 200) {
          const sowIdsData = res?.data?.sows || [];
          const sowids = sowIdsData.map((sows) => ({
            label: sows.member_name, // Corrected the typo from 'lable' to 'label'
            id: sows.sow_id, // 'id' will hold the sow_id
            // title: sows.title || "Title Not Available",  // Assuming the title is present in the response
          }));
          setSowIds(sowids);
        } else {
          console.error("Failed to fetch SoW IDs:", res);
        }
      } catch (error) {
        console.error("Error fetching SoW IDs:", error);
      }
    };
    const fetchUserIds = async () => {
      try {
        console.log("inside fetchuserid");
        const res = await getRequest("admin/userid-details");
        if (res?.status === 200) {
          const userIdsData = res?.data?.emp_list || [];
          const formattedUserIds = userIdsData.map((item) => ({
            id: item.user_id,
          }));
          setUserIds(formattedUserIds);
        } else {
          console.error("Failed to fetch user IDs:", res);
        }
      } catch (error) {
        console.error("Error fetching user IDs:", error);
      }
    };
    const fetchApplications = async () => {
      try {
        const res = await getRequest("/admin/unique-applications");
        if (res?.status === 200) {
          const applications = res?.data?.applications || [];
          console.log("Fetched applications from API:", applications);

          const appNamesWithIds = applications.map((app) => ({
            app_id: app.app_id || "Unknown ID",
            app_name: app.app_name || "Unknown App",
          }));

          setAppData(appNamesWithIds);
        }
      } catch (error) {
        console.error("Error fetching applications:", error);
      }
    };

    if (addUserOpen) {
      fetchApplications();
      fetchClientData();
      fetchDepartments();
      fetchSowIds();
      fetchUserIds();
    }
  }, [addUserOpen]);

  const fetchUserNameEmail = async (userId) => {
    try {
      console.log("Fetching user details with userId:", userId);

      const res = await getRequest("admin/add-username-email-details", {
        user_id: userId,
      });

      console.log("Response from fetchUserNameEmail:", res);

      if (res?.status === 200) {
        const userNameEmail = res?.data?.emp_list[0] || {};
        console.log("User details fetched:", userNameEmail);

        setNewUser((prevUser) => ({
          ...prevUser,
          username: userNameEmail.name || "",
          email: userNameEmail.email || "",
        }));
      } else {
        console.error("Failed to fetch user details:", res);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const handleAddUser = async () => {
    try {
      if (showAdditionalFields && (!newUser.clients || !newUser.deptId)) {
        toast.error(
          "Clients, Department, and SoW ID are required for selected applications."
        );
        return;
      }

      const formData = new FormData();

      // User and General Information
      formData.append("user_id", newUser?.userId); // User ID
      formData.append("username", newUser?.username || "");
      formData.append("email", newUser?.email || "");
      formData.append("dept_id", newUser?.deptId || ""); // dept ID from selected depit
      formData.append("client_ids", newUser?.clients || ""); // Clients as a comma-separated string
      formData.append("is_superadmin", newUser?.isSuperAdmin); // Clients as a comma-separated string
      // Selected App IDs - comma-separated
      const allowedAppIds = permissions
        .map((permission) => permission?.application)
        .filter((app) => app !== "");
      formData.append("selected_app_ids", allowedAppIds.join(",")); // Send selected app IDs

      // App-AccessLevel Mapping
      const appRoles = permissions
        .map((permission) => {
          if (permission?.application && permission.access_level) {
            return `${permission?.application}:${permission.access_level}`;
          }
          return null;
        })
        .filter((appRole) => appRole !== null); // Filter out null values

      formData.append("app_roles", appRoles.join(",")); // App-access level mapping

      // SoW (Statement of Work) IDs
      formData.append(
        "sows",
        newUser?.sowId?.map((sow) => sow.id).join(",") || ""
      );

      // Handle image upload
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput?.files[0]) {
        formData.append("image", fileInput.files[0]);
      }

      // Post the form data to the /register endpoint
      const res = await postFormDataRequest("/admin/register", formData);

      console.log("Response data:", res?.data);

      if (res?.status === 200) {
        const addedUser = res?.data?.user;
        console.log("Added User:", addedUser);
        toast.success("User added successfully");
        handleAddUserClose();
        window.location.reload();
      } else {
        toast.error(` ${res?.data?.error}`);
      }
    } catch (error) {
      toast.error("Failed to add user");
      console.error("Error adding user:", error);
    }
  };

  const handleClearClose = async () => {
    handleClear();
    handleAddUserClose();
  };

  // Add a new permission row
  const handleAddPermission = () => {
    if (permissions.length > 0) {
      const lastPermission = permissions[permissions.length - 1];
      if (!lastPermission.application || !lastPermission.access_level) {
        return; // Do not add a new row if the last one is empty
      }
    }
    setPermissions([
      ...permissions,
      {
        application: "",
        access_level: "",
        read: false,
        write: false,
        delete: false,
      },
    ]);
  };
  // Handle permission changes for both automatic permissions
  const handlePermissionChange = (index, typeOrPermissions, value) => {
    if (typeOrPermissions === "application") {
      // Update permissions first
      const updatedPermissions = [...permissions];

      if (!updatedPermissions[index]) {
        updatedPermissions[index] = {
          application: "",
          access_level: "",
          read: false,
          write: false,
          delete: false,
        };
      }

      if (typeof typeOrPermissions === "object") {
        updatedPermissions[index] = {
          ...updatedPermissions[index],
          ...typeOrPermissions,
        };
      } else {
        updatedPermissions[index] = {
          ...updatedPermissions[index],
          [typeOrPermissions]: value,
        };
      }

      // Set permissions with the new value.
      setPermissions(updatedPermissions);

      // Check if any app is 1, 2 or 3
      const shouldShowAdditionalFields = updatedPermissions.some(
        (perm) =>
          perm.application && [1, 2, 3].includes(parseInt(perm.application))
      );

      setShowAdditionalFields(shouldShowAdditionalFields);

      // Clear fields if no app is 1,2 or 3.
      if (!shouldShowAdditionalFields) {
        setNewUser((prev) => ({
          ...prev,
          clients: "",
          deptId: "",
          sowId: [],
          sows: "",
        }));
      }

      console.log("Updated Permissions by Pravin", updatedPermissions);
      console.log("Permission index being updated by mote:", index);
    } else {
      const updatedPermissions = [...permissions];

      if (!updatedPermissions[index]) {
        updatedPermissions[index] = {
          application: "",
          access_level: "",
          read: false,
          write: false,
          delete: false,
        };
      }

      if (typeof typeOrPermissions === "object") {
        updatedPermissions[index] = {
          ...updatedPermissions[index],
          ...typeOrPermissions,
        };
      } else {
        updatedPermissions[index] = {
          ...updatedPermissions[index],
          [typeOrPermissions]: value,
        };
      }

      setPermissions(updatedPermissions);
    }
  };
  // Delete a permission row
  const handleDeletePermission = (index) => {
    const updatedPermissions = permissions.filter((_, i) => i !== index);
    setPermissions(updatedPermissions);

    // Duplicate logic from handlePermissionChange
    const shouldShowAdditionalFields = updatedPermissions.some(
      (perm) =>
        perm.application && [1, 2, 3].includes(parseInt(perm.application))
    );

    setShowAdditionalFields(shouldShowAdditionalFields);

    if (!shouldShowAdditionalFields) {
      setNewUser((prev) => ({
        ...prev,
        clients: "",
        deptId: "",
        sowId: [],
        sows: "",
      }));
    }
  };

  // Clear the form fields
  const handleClear = () => {
    setNewUser({
      userId: "",
      username: "",
      email: "",
      status: "",
      isSuperAdmin: 0,
      clients: "",
      deptId: "",
      sowId: [],
      sows: "",
      allowed_app_ids: [],
    });
    setPermissions([
      {
        application: "",
        access_level: "",
        read: false,
        write: false,
        delete: false,
      },
    ]);
    setShowAdditionalFields(false);
    setImagePreview(null);
  };

  // Handle image upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  return (
    <Modal
      open={addUserOpen}
      onClose={handleClearClose}
      BackdropProps={{
        timeout: 100,
        style: {
          backdropFilter: "blur(5px)", // Adjust the blur radius as needed
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: Add a semi-transparent background
        },
      }}
    >
      <Box className="add-user-modal" sx={{ bgcolor: "background.paper" }}>
        <Box className="header">
          <Typography variant="h6">Add User</Typography>
          <IconButton onClick={handleClearClose} className="close-button">
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider className="divider" />

        <Grid container spacing={2} className="form-grid">
          <Grid item xs={9}>
            <Grid container spacing={1}>
              {/* User ID */}
              <Grid item xs={6}>
                <Autocomplete
                  options={userIds}
                  getOptionLabel={(option) => option?.id || ""}
                  value={
                    userIds.find((user) => user.id === newUser.userId) || null
                  }
                  onChange={(e, newValue) => {
                    if (newValue?.id) {
                      setNewUser((prevUser) => ({
                        ...prevUser,
                        userId: newValue.id,
                      }));
                      console.log("Selected User ID:", newValue.id);
                      fetchUserNameEmail(newValue.id);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="User ID"
                      size="small"
                      className="input-field"
                    />
                  )}
                  fullWidth
                />
              </Grid>
              {/* User Name */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="User Name"
                  name="username"
                  value={newUser?.username || ""}
                  size="small"
                  className="input-field"
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled
                />
              </Grid>
              {/* E-mail ID */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="E-mail ID"
                  name="email"
                  value={newUser?.email || ""}
                  size="small"
                  className="input-field"
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled
                />
              </Grid>
              {/* Select issuperadmin */}
              <Grid item xs={6}>
                <Autocomplete
                  options={superAdminOptions}
                  fullWidth
                  getOptionLabel={(option) => option.label}
                  value={superAdminOptions.find(
                    (opt) => opt.value === (newUser.isSuperAdmin ?? 0)
                  )} // De
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  } // Fix compari
                  onChange={(event, newValue) => {
                    setNewUser((prevUser) => ({
                      ...prevUser,
                      isSuperAdmin: newValue?.value ?? 0, // Store value as 1 or 0, default to 0
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Make it a Super Admin?"
                      variant="outlined"
                      size="small"
                      className="input-field"
                    />
                  )}
                />
              </Grid>

              {showAdditionalFields && (
                <>
                  {/* Clients */}
                  <Grid item xs={6}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      disableCloseOnSelect
                      options={[
                        { id: "ALL", label: "Select All" },
                        ...clientData,
                      ]}
                      fullWidth
                      value={(newUser.clients || "")
                        .split(",")
                        .map((id) =>
                          clientData.find((c) => c.id.toString() === id)
                        )
                        .filter((c) => c !== undefined)}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      onChange={(event, value) => {
                        const isAllSelected = value.find(
                          (opt) => opt.id === "ALL"
                        );
                        const allSelected =
                          newUser?.clients?.split(",")?.length ===
                          clientData.length;

                        if (isAllSelected) {
                          const newClientIds = allSelected
                            ? ""
                            : clientData.map((c) => c.id).join(",");

                          setNewUser((prevUser) => ({
                            ...prevUser,
                            clients: newClientIds,
                          }));
                        } else {
                          const selectedClientIds = value
                            .map((val) => val.id)
                            .filter((id) => id !== "ALL")
                            .join(",");

                          setNewUser((prevUser) => ({
                            ...prevUser,
                            clients: selectedClientIds,
                          }));
                        }
                      }}
                      renderOption={(props, option, { selected }) => {
                        const { key, ...rest } = props;
                        const isAll = option.id === "ALL";
                        const allSelected =
                          newUser?.clients?.split(",")?.length ===
                          clientData.length;

                        return (
                          <li key={key} {...rest}>
                            <Checkbox
                              checked={isAll ? allSelected : selected}
                              style={{ marginRight: 8 }}
                            />
                            {option.label}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Clients"
                          size="small"
                          className="input-autocomplete"
                          InputProps={{
                            ...params.InputProps,
                            style: { height: "40px" },
                          }}
                        />
                      )}
                      required
                      sx={{
                        ".MuiAutocomplete-inputRoot": {
                          height: "40px",
                          overflow: "hidden",
                        },
                      }}
                    />
                  </Grid>

                  {/* Select Department */}
                  <Grid item xs={6}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      disableCloseOnSelect
                      options={[
                        { dept_id: "ALL", dept_name: "Select All" },
                        ...departments,
                      ]}
                      fullWidth
                      value={(newUser.deptId || "")
                        .split(",")
                        .map((id) =>
                          departments.find((d) => d.dept_id.toString() === id)
                        )
                        .filter((dept) => dept !== undefined)}
                      getOptionLabel={(option) => option.dept_name}
                      isOptionEqualToValue={(option, value) =>
                        option.dept_id === value.dept_id
                      }
                      onChange={(event, value) => {
                        const isAllSelected = value.find(
                          (opt) => opt.dept_id === "ALL"
                        );
                        const allSelected =
                          newUser?.deptId?.split(",")?.length ===
                          departments.length;

                        if (isAllSelected) {
                          const newDeptIds = allSelected
                            ? ""
                            : departments.map((d) => d.dept_id).join(",");

                          setNewUser((prevUser) => ({
                            ...prevUser,
                            deptId: newDeptIds,
                          }));
                        } else {
                          const selectedDeptIds = value
                            .map((val) => val.dept_id)
                            .filter((id) => id !== "ALL")
                            .join(",");

                          setNewUser((prevUser) => ({
                            ...prevUser,
                            deptId: selectedDeptIds,
                          }));
                        }
                      }}
                      renderOption={(props, option, { selected }) => {
                        const { key, ...rest } = props;
                        const isAll = option.dept_id === "ALL";
                        const allSelected =
                          newUser?.deptId?.split(",")?.length ===
                          departments.length;

                        return (
                          <li key={key} {...rest}>
                            <Checkbox
                              checked={isAll ? allSelected : selected}
                              style={{ marginRight: 8 }}
                            />
                            {option.dept_name}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Department"
                          variant="outlined"
                          size="small"
                          className="input-field"
                          InputProps={{
                            ...params.InputProps,
                            style: { height: "40px" },
                          }}
                        />
                      )}
                      required
                      sx={{
                        ".MuiAutocomplete-inputRoot": {
                          height: "40px",
                          overflow: "hidden",
                        },
                      }}
                    />
                  </Grid>

                  {/* SoW ID with Autocomplete */}
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      disableCloseOnSelect
                      options={sowIds} // sowIds array populated by the fetchSowIds function
                      value={newUser.sowId || []} // Ensures selected values are updated properly
                      getOptionLabel={(option) => `${option.label} `} // Shows member_name and title
                      isOptionEqualToValue={(option, value) =>
                        !!value && option.id === value.id
                      } // Compare by id to ensure correct matching
                      renderOption={(props, option, { selected }) => {
                        const { key, ...rest } = props;
                        return (
                          <li key={key} {...rest}>
                            <Checkbox
                              checked={selected}
                              style={{ marginRight: 8 }}
                            />
                            {option.label}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="SoW ID"
                          variant="outlined"
                          size="small"
                          className="input-select"
                        />
                      )}
                      onChange={(e, value) => {
                        const sowidsString = value
                          .map((val) => val.id)
                          .join(","); // Creates comma-separated sow_id string
                        setNewUser((prevUser) => ({
                          ...prevUser,
                          sowId: value, // Store the entire selected SoW objects
                          sows: sowidsString, // Updates newUser state with the comma-separated sow_id string
                        }));
                        console.log(
                          "Selected SoW IDs (comma-separated):",
                          sowidsString
                        ); // Debugging log
                      }}
                      fullWidth
                      sx={{
                        ".MuiAutocomplete-inputRoot": {
                          height: "40px", // Keeps input height fixed
                          overflow: "hidden", // Prevents content from overflowing
                        },
                      }}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>

          {/* Image Upload Section */}
          <Grid item xs={3} className="image-upload-section">
            <Box className="image-preview">
              {imagePreview ? (
                <img
                  src={imagePreview}
                  alt="Uploaded Preview"
                  className="preview-img"
                />
              ) : (
                <img
                  src="/profile-image.png"
                  alt="Profile Placeholder"
                  className="preview-img"
                />
              )}
            </Box>
            <Button
              variant="contained"
              component="label"
              className="upload-btn"
            >
              Upload Picture
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleImageUpload}
              />
            </Button>
          </Grid>
        </Grid>

        <PermissionsTable
          permissions={[...permissions]} // Combine automatic  permissions
          setPermissions={setPermissions}
          appData={appData}
          handlePermissionChange={handlePermissionChange}
          handleDeletePermission={handleDeletePermission}
        />

        <Box className="modal-actions">
          <Grid className="left-button">
            <Button
              variant="contained"
              onClick={handleAddPermission}
              className="add-permission-btn"
              startIcon={<AddCircleIcon sx={{ color: "white" }} />}
            >
              Add Permission
            </Button>
            <Button
              variant="contained"
              className="clear-btn"
              onClick={handleClear}
              startIcon={<BackspaceIcon sx={{ color: "white" }} />}
            >
              Clear
            </Button>
          </Grid>
          <Button
            variant="contained"
            onClick={handleAddUser}
            className="submit-btn"
            startIcon={
              <PersonAddIcon style={{ color: "#fff" }}></PersonAddIcon>
            }
          >
            Add User
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddUserModal;
